export default __webpack_public_path__ + "static/media/623-mark.43257ee3.svg";